// @flow

import {DateTime} from 'luxon';
import type {ConfigFunction as MarkdocFunctionSchema} from '@markdoc/markdoc';

export const before: MarkdocFunctionSchema = {
  render(parameters, config): boolean {
    const timestamp = DateTime.fromISO(parameters['0']);
    return timestamp.valueOf() > DateTime.local().valueOf();
  },
};
